import {
  createReducer,
  defaultGetReducer,
  defaultListInitialState
} from 'utils';
import { GET_PROFILE_BOOKINGS } from '../../constants/profile';

const bookingsInitial = defaultListInitialState();
const bookings = createReducer(bookingsInitial, {
  [GET_PROFILE_BOOKINGS]: defaultGetReducer
});

export default bookings;



// WEBPACK FOOTER //
// ./src/reducers/profile/bookings.js